export default "__VITE_ASSET__BfgVgHP3__"